export default __webpack_public_path__ + "static/media/quality-losses.02819bc1.svg";